import React from "react";
import { Flex, IconButton, Select, Text } from "@chakra-ui/react";
import { ArrowRightSmallIcon, ArrowLeftSmallIcon } from "@/styles/icons";

interface Pagination2Props {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

export const Pagination2: React.FC<Pagination2Props> = ({ currentPage, totalPages, onPageChange }) => {
  const handlePrev = () => {
    if (currentPage + 1 > 1) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (currentPage + 1 < totalPages) {
      onPageChange(currentPage + 1);
    }
  };

  const handleSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    onPageChange(Number(e.target.value));
  };

  return (
    <Flex 
        w="100%" 
        align="center" 
        gap={2}
        justify="space-between"
    >
      <Text fontSize="md" color="gray.500">
        {currentPage + 1} de {totalPages === 0 ? 1 : totalPages} páginas
      </Text>
      <Flex align="center" gap={1} ml={4}>
        <IconButton
          aria-label="Página anterior"
          icon={<ArrowLeftSmallIcon />}
          onClick={handlePrev}
          isDisabled={currentPage + 1 === 1}
          size="sm"
          variant="ghost"
        />
        <Select
          value={currentPage}
          onChange={handleSelect}
          size="sm"
          width="60px"
          borderRadius="4px"
          _focus={{
            borderColor: "pink.500",
          }}
        >
          {totalPages === 0 ? (
            <option value="1">1</option>
          ) : (
            Array.from({ length: totalPages }, (_, i) => (
              <option key={i + 1} value={i + 1}>
                {i + 1}
              </option>
            ))
          )}
        </Select>
        <IconButton
          aria-label="Próxima página"
          icon={<ArrowRightSmallIcon />}
          onClick={handleNext}
          isDisabled={currentPage + 1 === totalPages}
          size="sm"
          variant="ghost"
        />
      </Flex>
    </Flex>
  );
}; 